/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import { Component, ViewChildren, QueryList } from '@angular/core';

import { MappingModel } from '../../models/mapping.model';
import { ConfigModel } from '../../models/config.model';
import { Field } from '../../models/field.model';

import { ModalWindowComponent } from '../modal-window.component';
import { MappingSelectionSectionComponent } from './mapping-selection-section.component';

@Component({
  selector: 'mapping-selection',
  template: `<div class="MappingSelectionComponent" *ngIf="mappings">
  <div class="header">
    <div class="sourceTargetHeader">{{ selectedField.isSource() ? 'Source' : 'Target' }}</div>
    <div class="pathHeader">
      <div class="pathName">{{ getFormattedOutputPath(selectedField.path, false) }}</div>
      <div class="fieldName">{{ getFormattedOutputPath(selectedField.path, true) }}</div>
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
    <button class="btn btn-primary addButton" (click)="addMapping()">
      <i class="fa fa-plus"></i>Add New Mapping
    </button>
  </div>
  <div class="MappingSelectionOptions">
    <mapping-selection-section *ngFor="let mapping of mappings; let i = index; let odd=odd; let even=even;" [mapping]="mapping"
      [outputNumber]="i" [selected]="i == 0" [selectedCallback]="selectionChanged" [selectedFieldIsSource]="selectedField.isSource()"
      [parentComponent]="this" [isOddRow]="odd" #mappingSection>
    </mapping-selection-section>
  </div>
</div>`,
})

export class MappingSelectionComponent {
  modalWindow: ModalWindowComponent;
  mappings: MappingModel[];
  selectedField: Field = null;
  cfg: ConfigModel;

  @ViewChildren('mappingSection') sectionComponents: QueryList<MappingSelectionSectionComponent>;

  private selectedMappingComponent: MappingSelectionSectionComponent = null;

  selectionChanged(c: MappingSelectionSectionComponent) {
    const self: MappingSelectionComponent = c.parentComponent as MappingSelectionComponent;
    const oldSelectedItem: MappingSelectionSectionComponent = self.getSelectedMappingComponent();
    oldSelectedItem.selected = false;
    c.selected = true;
    self.selectedMappingComponent = c;
  }

  getFormattedOutputPath(path: string, nameOnly: boolean) {
    path = path.replace('.', '/');
    const index: number = path.lastIndexOf('/');
    const fieldName: string = (index == -1) ? path : path.substr(path.lastIndexOf('/') + 1);
    path = (index == -1) ? '' : path.substr(0, path.lastIndexOf('/') + 1);
    return nameOnly ? fieldName : path;
  }

  addMapping() {
    this.cfg.mappingService.addNewMapping(this.selectedField, false);
    this.modalWindow.close();
  }

  getSelectedMapping(): MappingModel {
    return this.getSelectedMappingComponent().mapping;
  }

  private getSelectedMappingComponent(): MappingSelectionSectionComponent {
    if (this.selectedMappingComponent == null) {
      for (const c of this.sectionComponents.toArray()) {
        if (c.selected) {
          this.selectedMappingComponent = c;
          break;
        }
      }
    }
    return this.selectedMappingComponent;
  }

}
